module.exports = __webpack_public_path__ + "static/media/incomeIcon.aaebb415.svg";